<template>
  <div id="contenedor-exportar-excel-observaciones-auditorias-etiquetas">
    <template v-if="listItem">
      <v-list-item @click="generarExcelObservacionesAuditoriasEtiquetas" link>
        <v-list-item-icon class="mx-2">
          <v-icon> mdi-file-excel </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title> Exportar Etiquetas </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
    <template v-else>
      <v-btn
        text
        outlined
        color="secondary"
        small
        rounded
        @click="generarExcelObservacionesAuditoriasEtiquetas"
      >
        <v-icon left> mdi-file-excel </v-icon>
        Exportar
      </v-btn>
    </template>
  </div>
</template>

<script>
import mixGenerarExcel from '@/helpers/mixGenerarExcel';

// Fila en la que inician los datos con titulos del excel
const filaTitulos = 2;
// const filaSubtitulos = filaTitulos + 1;
const filaInicioDatos = filaTitulos + 1;

export default {
  name: 'ExcelObservacionesAuditoriasEtiquetas',
  mixins: [mixGenerarExcel],
  props: {
    listItem: {
      type: Boolean,
      required: false,
      default: false,
    },
    etiquetasConDesgloses: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      formularioValido: false,
      estaCargando: false,
      nombreDocumento: 'OBSERVACIONES DE AUDITORIAS POR ETIQUETAS',
      configuracionExcel: {},
      // Estilo del header
      estiloHeader: {
        font: {
          bold: true,
        },
        alignment: {
          horizontal: 'center',
          vertical: 'center',
          wrapText: true,
        },
      },
      headersColumnas: [
        {
          value: 'ETIQUETA',
          nombreColumna: 'etiqueta',
          orden: 1,
        },
        {
          value: 'DESCRIPCION DESGLOSE',
          nombreColumna: 'descripcionDesglose',
          orden: 2,
        },
        {
          value: 'COMENTARIO DESGLOSE',
          nombreColumna: 'comentarioDesglose',
          orden: 3,
        },
        {
          value: 'FECHA VENCIMIENTO',
          nombreColumna: 'fechaVencimiento',
          orden: 4,
        },
        {
          value: 'CONTRATO',
          nombreColumna: 'contrato',
          orden: 5,
        },
        {
          value: 'RESIDENTE',
          nombreColumna: 'residente',
          orden: 6,
        },
        {
          value: 'CONTRATISTA',
          nombreColumna: 'contratista',
          orden: 7,
        },
        {
          value: 'ENTE',
          nombreColumna: 'ente',
          orden: 8,
        },
        {
          value: 'EJERCICIO',
          nombreColumna: 'ejercicio',
          orden: 9,
        },
        {
          value: 'AUDITORIA',
          nombreColumna: 'auditoria',
          orden: 10,
        },
        {
          value: 'INFORME',
          nombreColumna: 'informe',
          orden: 11,
        },
        {
          value: 'NUM OBSERVACION',
          nombreColumna: 'numeroObservacion',
          orden: 12,
        },
        {
          value: 'DESCRIPCION OBSERVACION',
          nombreColumna: 'descripcionObservacion',
          orden: 13,
        },
        {
          value: 'ESTATUS OBSERVACION',
          nombreColumna: 'estatusObservacion',
          orden: 14,
        },
        {
          value: 'COMENTARIO ESTATUS OBSERVACION',
          nombreColumna: 'comentarioEstatusObservacion',
          orden: 15,
        },
      ],
      noData: [
        {
          etiqueta: '',
          descripcionDesglose: '',
          comentarioDesglose: '',
          fechaVencimiento: '',
          contrato: '',
          residente: '',
          contratista: '',
          ente: '',
          ejercicio: '',
          auditoria: '',
          informe: '',
          numeroObservacion: '',
          descripcionObservacion: '',
          estatusObservacion: '',
          comentarioEstatusObservacion: '',
        },
      ],
      estilos: {
        centrado: {
          alignment: {
            horizontal: 'center',
            vertical: 'center',
          },
        },
        dinero: {
          numberFormat: '$#,##0.00',
        },
      },
    };
  },
  methods: {
    async generarExcelObservacionesAuditoriasEtiquetas() {
      const data = await this.crearExcelObservacionesAuditorias;
      await this.mixGenerarExcel(data);
    },
    getResidente(contrato) {
      if (!contrato) return '';
      const responsable = contrato.responsables.find(
        (contratoResponsable) => contratoResponsable.principal,
      );
      if (!responsable) return '';
      return responsable.funcionario.nombre;
    },
  },
  computed: {
    getHeaders() {
      const headers = this.headersColumnas
        .map((header) => header.value)
        .sort((a, b) => a.orden - b.orden);
      return headers;
    },
    getColumnas() {
      const columnas = this.headersColumnas
        .map((columna) => columna.nombreColumna)
        .sort((a, b) => a.orden - b.orden);
      return columnas;
    },
    getDesglosesPorEtiquetas() {
      const desglosesConEtiquetas = [];
      this.etiquetasConDesgloses.forEach((etiqueta) => {
        if (etiqueta.detalles.length > 0) {
          etiqueta.detalles
            .sort((a, b) => new Date(a.fechaVencimiento) - new Date(b.fechaVencimiento))
            .forEach((detalle) => {
              desglosesConEtiquetas.push({
                etiqueta: etiqueta.descripcion,
                descripcionDesglose: detalle.texto,
                comentarioDesglose: detalle.comentarios,
                fechaVencimiento: this.$moment(detalle.fechaVencimiento).format('DD/MM/YYYY'),
                contrato: detalle.contrato?.numero,
                residente: this.getResidente(detalle.contrato),
                contratista: detalle.contrato?.contratista.nombreRazonSocial,
                ente:
                detalle.auditoriaObservacion.auditoriaInforme.auditoria.enteFiscalizador
                  .descripcion,
                ejercicio: {
                  value: detalle.auditoriaObservacion.auditoriaInforme.auditoria.ejercicio,
                  estilo: this.estilos.centrado,
                },
                auditoria: detalle.auditoriaObservacion.auditoriaInforme.auditoria.nombre,
                informe: detalle.auditoriaObservacion.auditoriaInforme.nombre,
                numeroObservacion: detalle.auditoriaObservacion.numero,
                descripcionObservacion: detalle.auditoriaObservacion.descripcion,
                estatusObservacion: detalle.auditoriaObservacion.estatus,
                comentarioEstatusObservacion: detalle.auditoriaObservacion.comentarios,
              });
            });
        }
      });
      return desglosesConEtiquetas
        .sort((a, b) => a.etiqueta.localeCompare(b.etiqueta));
    },
    crearDatosDocumento() {
      const datosDocumento = [];
      datosDocumento.push({
        value: `DESGLOSE DE OBSERVACIONES POR ETIQUETAS AL ${new Date().toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }).toUpperCase()}`,
        row: 1,
        col: 1,
        estilo: {
          font: {
            size: 14,
            bold: true,
          },
          alignment: {
            horizontal: 'left',
            vertical: 'center',
          },
        },
        combinar: {
          row: 1,
          col: 13,
        },
      });
      return datosDocumento;
    },
    crearExcelObservacionesAuditorias() {
      const datosDocumento = this.crearDatosDocumento;
      const dataHeaders = this.getHeaders;
      const nombreDeColumnas = this.getColumnas;
      const bodyData = this.getDesglosesPorEtiquetas.length > 0
        ? this.getDesglosesPorEtiquetas : this.noData;
      const data = {
        excelData: {
          configuration: this.configuracionExcel,
          header: {
            filaInicio: filaTitulos,
            estilo: this.estiloHeader,
            datosDocumento: [...datosDocumento],
            data: [...dataHeaders],
          },
          body: {
            nombreDeColumnas,
            filaInicio: filaInicioDatos,
            data: bodyData,
          },
        },
      };
      return data;
    },
  },
};
</script>

<style lang="scss" scoped></style>
